import React from 'react';
import { Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const DataManagementDictionaryDataExistsCell = ({ dataTableExists }) => (
  <Table.Cell>
    {dataTableExists === true && (<FormattedMessage id="dataset.data.table.exists.yes" />)}
    {dataTableExists === false && (<FormattedMessage id="dataset.data.table.exists.no" />)}
  </Table.Cell>
);

export default DataManagementDictionaryDataExistsCell;
